import React from "react";
import { Text, PaddedContainer } from "@disco/disco_core";

import useWidgetOffer from "../../hooks/useWidgetOffer";
import { OFFER_TYPE } from "../../conf";

const OfferInfo = () => {
    const { activeOffer, isOfferClaimed } = useWidgetOffer();

    const {
        name: advertiserName,
        incentive_heading: incentiveHeading,
        incentive_code: incentiveCode,
        incentive_subheading: incentiveSubheading,
        incentive_type: incentiveType,
    } = activeOffer;

    return (
        <PaddedContainer>
            <Text size="body" style={{ fontWeight: 600 }}>{advertiserName}</Text>
            <Text size="lg-body" style={{ fontWeight: 700 }}>
                {isOfferClaimed ? `You've got ${incentiveHeading}` : incentiveHeading}
            </Text>
            <Text size="body" color="mid" style={{ fontWeight: 400 }}>
                {isOfferClaimed && incentiveType === OFFER_TYPE.PROMO_CODE ? (
                    <>
                        Use code: <b>{incentiveCode}</b>
                    </>
                ) : (
                    incentiveSubheading || "On your next purchase"
                )}
            </Text>
        </PaddedContainer>
    )
}

export default OfferInfo;